module.exports = __webpack_public_path__ + "img/your-subscription-is-about-expire-4-en.5f44da6.png";